import * as React from 'react'
import { ReactElement } from 'react'
import { formatNumber, multiplyRate } from '../../../helpers/numberHelper'
import MoneyText from '../../Text/Currency/MoneyText'
import { TravelOverviewDto } from '../../../config/registrationConfig'
import ViewRegistrationRow, {
    ViewRegistrationColumnProps,
    ViewRegistrationColumns,
    ViewRegistrationRowProps,
} from '../Registration/ViewRegistrationRow'
import DistanceText from '../../Text/Distance/DistanceText'
import { TravelListProps } from './TravelList'

type Props = ViewRegistrationRowProps<TravelOverviewDto, TravelListProps>
type ColumnProps = ViewRegistrationColumnProps<TravelOverviewDto, TravelListProps>

function Columns(props: ColumnProps): ReactElement {
    switch (props.column.key) {
        case 'distance':
            return <DistanceText value={formatNumber(props.item.distance)} unit="km" />
        case 'subtotal':
            return <MoneyText value={multiplyRate(props.item.distance, props.item.rate)} />
    }

    return <ViewRegistrationColumns<TravelOverviewDto, TravelListProps> {...props} />
}

export default function ViewTravelRow(props: Props): ReactElement {
    return <ViewRegistrationRow<TravelOverviewDto, TravelListProps> {...props} columns={Columns} />
}
